import axios, { AxiosResponse } from 'axios';
import { ContentTypeItem, ContentTypeFormData } from '@src/types/knowledgeBase';

// ─── Resource shapes ────────────────────────────────────────────────────────

export type TermsRes = {
  id: number;
  name: string;
  type_id: number;
  type?: ContentTypeItem;
  content: string;
  is_published?: boolean;
  published_at?: string;
};

/** Response shape for list endpoints — already grouped by type on the backend */
export type TermAndConditionGroupByTypeRead = {
  name: string;
  type_id: number;
  terms: TermsRes[];
};

export type TermCreateUpdatePayload = {
  name: string;
  type_id: number;
  content: string;
  is_published?: boolean;
  published_at?: string;
};

// ─── Terms & Conditions CRUD ─────────────────────────────────────────────────

export const getTerms = (params?: {
  type_id?: number;
}): Promise<AxiosResponse<TermAndConditionGroupByTypeRead[]>> =>
  axios.get(`term-and-conditions/`, { params });

export const getPublicTerms = (params?: {
  type_id?: number;
}): Promise<AxiosResponse<TermAndConditionGroupByTypeRead[]>> =>
  axios.get(`term-and-conditions/public`, { params });

export const getTermDetail = (id: number): Promise<AxiosResponse<TermsRes>> =>
  axios.get(`term-and-conditions/${id}/`);

export const createTerm = (
  data: TermCreateUpdatePayload
): Promise<AxiosResponse<TermsRes>> => axios.post(`term-and-conditions/`, data);

export const updateTerm = (
  id: number,
  data: Partial<TermCreateUpdatePayload>
): Promise<AxiosResponse<TermsRes>> =>
  axios.put(`term-and-conditions/${id}/`, data);

export const deleteTerm = (id: number) =>
  axios.delete(`term-and-conditions/${id}/`);

// ─── Term & Condition Types (Admin) ─────────────────────────────────────────

export const getTermTypes = (params?: {
  is_active?: boolean;
}): Promise<AxiosResponse<ContentTypeItem[]>> =>
  axios.get(`term-and-condition-types/`, { params });

export const createTermType = (
  data: ContentTypeFormData
): Promise<AxiosResponse<ContentTypeItem>> =>
  axios.post(`term-and-condition-types/`, data);

export const updateTermType = (
  id: number,
  data: Partial<ContentTypeFormData>
): Promise<AxiosResponse<ContentTypeItem>> =>
  axios.patch(`term-and-condition-types/${id}/`, data);

export const deleteTermType = (id: number) =>
  axios.delete(`term-and-condition-types/${id}/`);
